import React, { useContext } from 'react'
import { Row, Col, Card, Table } from 'react-bootstrap'
import { useUserDataAccesses } from 'api/hooks/use-user-data-accesses'
import TableLoading from 'shared/tables/table-loading'
import MutedText from 'shared/forms/muted-text'
import AccessToggle from 'duties/data-accesses/tabs/AccessToggle'
import { mapAccessType } from '../data-accesses/helper'
import UserContext from 'context/user-context'
import AccountAccess from './AccountAccess'

function DataAccessTab({ employeeId }) {
  const { municipality } = useContext(UserContext)
  const defaultParams = {
    page: 1,
    perPage: 25,
    employee_id: employeeId,
    hideNoAccess: true,
    hideInactiveRoles: true
  }

  const [params, setParams] = React.useState(defaultParams)

  const { isLoading, isSuccess, data } = useUserDataAccesses({
    params,
    options: { refetchOnWindowFocus: false }
  })

  const userDataAccesses = data?.user_data_accesses || []
  const roleDataAccesses = data?.role_data_accesses || []
  const glAccountAccess = data?.gl_account_access || []

  // Combine user and role data accesses, marking the source
  const allDataAccesses = [
    ...userDataAccesses.map(a => ({ ...a, source: 'user' })),
    ...roleDataAccesses.map(a => ({ ...a, source: 'role' }))
  ]

  return (
    <>
      <Row>
        <Col sm={12}>
          {isSuccess && (
            <AccountAccess
              accessData={glAccountAccess}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <Card className="border">
            <Card.Header className="bg-white">
              <Row>
                <Col sm={'auto'}>
                  <div className="text-info">Data Access</div>
                </Col>
                <Col sm={'auto'}>
                  <div className="d-flex justify-content-start ms-3">
                    <AccessToggle params={params} setParams={setParams} />
                  </div>
                </Col>
                <Col sm={'auto'}>
                  <div className="d-flex justify-content-start ms-3">
                    <div className="form-check form-switch mt-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="hideInactiveRoles"
                        checked={params.hideInactiveRoles}
                        onChange={() =>
                          setParams({
                            ...params,
                            hideInactiveRoles: !params.hideInactiveRoles
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="hideInactiveRoles"
                      >
                        Hide Inactive Roles
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              {/* TODO: Consolidate to a single Users (Employees) Table */}
              <Table responsive size="sm">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Access</th>
                    <th>Access Type</th>
                    <th>Program</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>From Role</th>
                  </tr>
                </thead>

                <tbody>
                  {isLoading && <TableLoading columns={7} />}
                  {isSuccess &&
                    allDataAccesses.map((a) => (
                      <tr key={`${a.source}-row-${a.id}`}>
                        <td>
                          <a
                            href={`/data-access/${a?.data_access?.id}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {a?.data_access?.name}{' '}
                          </a>
                          <br />
                          <MutedText>
                            {a?.data_access?.top_module_name}
                          </MutedText>
                        </td>
                        <td>
                          <MutedText className="ms-2">
                            {a.no_access ? 'No Access' : 'Access'}
                          </MutedText>
                        </td>

                        <td>
                          <MutedText className="ms-2">
                            {mapAccessType(municipality, a?.access_type)}
                          </MutedText>
                        </td>
                        <td>
                          <MutedText className="ms-2">
                            {a.program_name || a.program_id}
                          </MutedText>
                        </td>
                        <td>
                          <MutedText className="ms-2">
                            {a.start1}
                          </MutedText>
                        </td>
                        <td>
                          <MutedText className="ms-2">
                            {a.end1}
                          </MutedText>
                        </td>
                        <td>
                          {a?.role?.id || a?.role_id ? (
                            <a
                              href={`/roles/${a?.role?.id || a?.role_id}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {a?.role?.name}{' '}
                            </a>
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default DataAccessTab
